<template>
    <main role="main">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="page-con">
            <div class="boundary">
            <h3>{{ $t('HEADER.OURMEMBERS') }}</h3>
            <div class="detailed-con" v-if="datas.length == 0 && !isLoading">
                <div class="oops">
                    <img src="../../../static/images/10/oops.png" alt="">
                </div>
            </div>
            <div v-if="isLoading" style="min-height:600px"></div>
            <ul>
                <li v-for="(item) in datas" :key="item.id">
                    <div class="img-box">
                        <img :src="item.data.src" :alt="item.data.name">
                    </div>
                    <div class="name-box">
                        <div class="jobTitle">
                            <p>{{item.data.center_role}}</p>
                        </div>
                        <h4>{{item.data.name}}<span v-html="item.data.job_title"></span></h4>
                        <p  v-html="item.data.experience.replace('rgb','') "></p>
                    </div>
                    <div class="list-box" :class="{'list-box-en':lang=='en'}">
                        <ol>
                        <li><p>{{ $t('OURMEMBER.EDUCATION') }}</p><p :class="{ 'word-wrap-break-word':lang=='en' }">{{item.data.education}}</p></li>
                        <li><p>{{ $t('OURMEMBER.EXPERTISE') }}</p><p :class="{ 'word-wrap-break-word':lang=='en' }">{{item.data.expertise}}</p></li>
                        <li><p>{{ $t('OURMEMBER.PHONE') }}</p><p>{{item.data.phone}}</p></li>
                        <li><p>E-mail</p><p class="job-mail">{{item.data.email}}</p></li>
                        </ol>
                    </div>
                </li>
            </ul>
            </div>
            
        </div>
        <IndexFooter></IndexFooter>
    </main>
</template>
<script>
import {fb, db } from '../../firebase'
export default {
    name: 'ServiceDetail',
    data () {
        return {
            datas:[],
            isLoading: false,
            fullPage: true,
            lang:''
        }
    },
    mounted () {
        this.lang = localStorage.getItem('language') || 'zh';
        this.Get();
    },
    methods: {
        Get(){
            this.isLoading = true;
            this.datas = [];    
            // 取得列表
            db.collection(this.$t('DB.FACULTY')).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    var data = {"id": doc.id, "data": doc.data()};
                    
                    this.datas.push(data);
                });
                this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);
                this.isLoading = false;
            }).catch((error) => {
                console.log("Error getting document:", error);
                this.isLoading = false;
            });
        }
    }
}
</script>
<style scoped>
.list-box-en ol > li p:first-child {
    width:115px !important;
}
.word-wrap-break-word{
    word-break:break-word !important;
    word-wrap:break-word !important;
}
</style>


// WEBPACK FOOTER //
// src/components/index/ServiceDetail.vue